"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var Types = require("types");
var CompareActions = require("@caddigital/sok-reducers/lib/actions/compare");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var fullscreen_1 = require("../../utils/fullscreen");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var Header_1 = require("./Header");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var components_1 = require("./components");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)() || 'en';
    return {
        user: state.auth.current.user,
        token: state.auth.current.token,
        searchOptions: state.files.searchOptions,
        filtering: state.files.searchOptions.filtering,
        folderPath: state.files.folderPath,
        compare: state.compare,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    navigateTo: function (url, filtering) {
        if (!filtering) {
            dispatch(FilesActions.resetSearchOptionsAction());
            dispatch(FilesActions.resetSortOptionsAction());
        }
        dispatch((0, connected_react_router_1.push)(url));
    },
    fetchBeforeRevision: function (uuid) {
        return dispatch(CompareActions.fetchBeforeRevisionRequest(uuid));
    },
    fetchAfterRevision: function (uuid) {
        return dispatch(CompareActions.fetchAfterRevisionRequest(uuid));
    },
    convert: function (revision) {
        return dispatch(CompareActions.GeneratePreviewActions.generatePreviewRequest(revision.uuid));
    },
    dispatch: dispatch
}); };
var StatePropsWitness = Types.extractReturnType(mapStateToProps);
var DispatchPropsWitness = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('compareTool', 'setCompareTool', 'SIDE_BY_SIDE'), (0, recompose_1.withState)('opactity', 'setOpacity', 0), (0, recompose_1.withState)('viewState', 'setViewState', 'FETCHING'), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchBeforeRevision(this.props.match.params.beforeRevisionUuid);
        this.props.fetchAfterRevision(this.props.match.params.afterRevisionUuid);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.match.params.beforeRevisionUuid !==
            prevProps.match.params.beforeRevisionUuid ||
            this.props.match.params.afterRevisionUuid !==
                prevProps.match.params.afterRevisionUuid) {
            this.props.fetchBeforeRevision(this.props.match.params.beforeRevisionUuid);
            this.props.fetchAfterRevision(this.props.match.params.afterRevisionUuid);
        }
        if ((this.props.compare.afterRevision.status ===
            prevProps.compare.afterRevision.status ||
            this.props.compare.beforeRevision.status ===
                prevProps.compare.beforeRevision.status) &&
            this.props.compare.afterRevision.status === 'FETCHED' &&
            this.props.compare.beforeRevision.status === 'FETCHED') {
            if (this.props.compare.afterRevision.revision.preview &&
                this.props.compare.afterRevision.revision.preview.status ===
                    'PROCESSED' &&
                this.props.compare.beforeRevision.revision.preview &&
                this.props.compare.beforeRevision.revision.preview.status ===
                    'PROCESSED' &&
                this.props.viewState !== 'VIEW') {
                this.props.setViewState('VIEW');
            }
            else if (!this.props.compare.afterRevision.revision.preview ||
                (!this.props.compare.beforeRevision.revision.preview &&
                    this.props.viewState !== 'CONVERTING')) {
                this.props.setViewState('CONVERTING');
                if (!this.props.compare.afterRevision.revision.preview) {
                    this.props.convert(this.props.compare.afterRevision.revision);
                }
                if (!this.props.compare.beforeRevision.revision.preview) {
                    this.props.convert(this.props.compare.beforeRevision.revision);
                }
            }
        }
    }
}), recompose_1.pure);
var CompareBreadCrumb = (0, recompose_1.pure)(function (props) {
    var path = props.folderPath.filter(function (x) { return x.id !== props.currentProject.rootFolder; });
    return (React.createElement(props.BreadCrumb, { filtering: 'NONE', navigateTo: props.navigateTo, path: path, currentProject: props.currentProject, searchResultsToggled: props.searchResultsToggled },
        React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/compare'))));
});
var FilesCompareViewPure = /** @class */ (function (_super) {
    __extends(FilesCompareViewPure, _super);
    function FilesCompareViewPure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilesCompareViewPure.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var searchResultsToggled = (props.searchOptions.searchString &&
            props.searchOptions.searchString !== '') ||
            (props.searchOptions.containsTermString &&
                props.searchOptions.containsTermString !== '') ||
            props.searchOptions.limitSearchToFolder.isSome() ||
            props.searchOptions.searchFileType.isSome();
        if (props.compare.beforeRevision.status === 'FAILED' ||
            props.compare.afterRevision.status === 'FAILED') {
            return (React.createElement("div", { className: 'content-wrapper-content' },
                React.createElement("div", { className: 'files-compare-view' },
                    React.createElement("div", { className: 'content' },
                        React.createElement("div", { className: 'viewer-container' },
                            React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/error')))))));
        }
        if (props.compare.beforeRevision.status === 'FETCHING' ||
            props.compare.afterRevision.status === 'FETCHING' ||
            props.viewState === 'FETCHING' ||
            props.viewState === 'CONVERTING') {
            return (React.createElement("div", { className: 'content-wrapper-content' },
                React.createElement("div", { className: 'files-compare-view' },
                    React.createElement("div", { className: 'content' },
                        React.createElement(CompareBreadCrumb, { searchResultsToggled: searchResultsToggled, selectedLanguage: props.selectedLanguage, folderPath: props.folderPath, currentProject: props.currentProject, currentFolder: props.currentFolder, navigateTo: props.navigateTo, BreadCrumb: props.BreadCrumb }),
                        React.createElement("div", { className: 'loader' },
                            React.createElement(sok_ui_1.LoadingSpinner, null),
                            (props.viewState === 'CONVERTING' ||
                                props.viewState === 'FETCHING') && (React.createElement("span", null, (0, translation_1.getLocalization)("files/compare/status/".concat(props.viewState === 'CONVERTING'
                                ? 'converting'
                                : 'loading')))))))));
        }
        if (props.compare.beforeRevision.status === 'FETCHED' &&
            props.compare.afterRevision.status === 'FETCHED' &&
            props.compare.beforeRevision.revision &&
            props.compare.afterRevision.revision) {
            return (React.createElement("div", { className: 'content-wrapper-content' },
                React.createElement("div", { className: 'files-compare-view' },
                    React.createElement("div", { className: 'content' },
                        React.createElement(CompareBreadCrumb, { searchResultsToggled: searchResultsToggled, selectedLanguage: props.selectedLanguage, folderPath: props.folderPath, currentProject: props.currentProject, currentFolder: props.currentFolder, navigateTo: props.navigateTo, BreadCrumb: props.BreadCrumb }),
                        React.createElement("div", { className: 'viewer-container' },
                            React.createElement("div", { className: 'fullscreen-container', ref: function (div) { return (_this.fullscreenContainer = div); } },
                                React.createElement(Header_1.Header, { beforeRevision: props.compare.beforeRevision.revision, afterRevision: props.compare.afterRevision.revision, compareTool: props.compareTool, setCompareTool: props.setCompareTool, opacity: props.opacity, setOpacity: props.setOpacity, container: this.fullscreenContainer, toggleFullscreen: function () {
                                        if (_this.fullscreenContainer) {
                                            (0, fullscreen_1.toggleFullscreen)(_this.fullscreenContainer);
                                        }
                                    }, moveToFolder: function () {
                                        if (props.compare.afterRevision.status !== 'FETCHED') {
                                            return;
                                        }
                                        var splitted = props.baseUrl.split('/');
                                        var path = splitted
                                            .slice(0, splitted.length - 3)
                                            .join('/');
                                        props.navigateTo("".concat(path, "/revisions/").concat(props.compare.afterRevision.revision.fileUuid), true);
                                    } }),
                                (function () {
                                    if (props.compareTool === 'DIFF') {
                                        return (React.createElement(components_1.Diff, { beforeRevision: props.compare.beforeRevision.revision, afterRevision: props.compare.afterRevision.revision }));
                                    }
                                    if (props.compareTool === 'OVERLAY') {
                                        return (React.createElement(components_1.Overlay, { beforeRevision: props.compare.beforeRevision.revision, afterRevision: props.compare.afterRevision.revision }));
                                    }
                                    if (props.compareTool === 'SIDE_BY_SIDE') {
                                        return (React.createElement(components_1.SideBySide, { beforeRevision: props.compare.beforeRevision.revision, afterRevision: props.compare.afterRevision.revision }));
                                    }
                                    return null;
                                })()))))));
        }
        return null;
    };
    return FilesCompareViewPure;
}(React.Component));
exports.default = enhance(FilesCompareViewPure);
